export enum Strategy {
  ECONOMIZER = 'Economizer',
  SHARED = 'Shared',
  STAGED = 'Staged',
  ENVIRONMENT = 'Environment Condition'
}